import React, { useContext, useMemo } from 'react';

export interface AccordionProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AccordionContext = React.createContext<AccordionProps | null>(null);

export const AccordionProvider: React.FC<React.PropsWithChildren<AccordionProps>> = ({ open, children, onOpenChange }) => {
  const value = useMemo(() => ({ open, onOpenChange }), [open, onOpenChange]);

  return (
    <AccordionContext.Provider value={value}>
      {children}
    </AccordionContext.Provider>
  );
};

export const useAccordionContext = (): AccordionProps | null => useContext(AccordionContext);

export function withAccordionContext<TProps>(Component: React.FC<TProps>) {
  const AccordionCard: React.FC<TProps & AccordionProps> = ({ open, onOpenChange, ...rest }) => (
    <AccordionProvider open={open} onOpenChange={onOpenChange}>
      <Component {...(rest as any)} />
    </AccordionProvider>
  );

  return AccordionCard;
}
